import axios, { AxiosStatic } from 'axios'
import { boot } from 'quasar/wrappers'

export default boot(({ app }) => {
  app.provide<AxiosStatic>('axios', axios)
})
